module.exports = __webpack_public_path__ + "img/FIN.10222c09.svg";